// src/components/Header.js
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Header.css";

import logo from "../assets/logoheader.png";
import wlogo from "../assets/wlogo.png";
import AppointmentModal from "../components/AppointmentModal";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  /* 🔍 SEARCH STATE */
  const [searchQuery, setSearchQuery] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  /* 🔍 SEARCH DATA (simple, editable) */
  const searchItems = [
    { label: "Eye Services", type: "route", path: "/services" },
    { label: "Cataract Treatment", type: "route", path: "/services" },
    { label: "LASIK Surgery", type: "route", path: "/services" },
    { label: "Doctors", type: "scroll", target: "doctors-list" },
    { label: "About Hospital", type: "route", path: "/about" },
    { label: "Privacy Policy", type: "route", path: "/privacy-policy" }
  ];

  /* ---------------- SCROLL EFFECT ---------------- */
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  /* ---------------- SCROLL TO DOCTORS ---------------- */
  const scrollToDoctors = () => {
    const targetId = "doctors-list";

    if (location.pathname === "/") {
      const el = document.getElementById(targetId);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById(targetId);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };

  /* ---------------- SEARCH LOGIC ---------------- */
  const filteredSuggestions = searchQuery.length >= 1
    ? searchItems.filter(item =>
        item.label.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  const handleSelectSuggestion = (item) => {
    if (item.type === "route") {
      navigate(item.path);
    } else if (item.type === "scroll") {
      scrollToDoctors();
    }

    setSearchQuery("");
    setShowSuggestions(false);
    closeMenu();
  };

  const handleKeyDown = (e) => {
    if (e.key !== "Enter") return;

    if (filteredSuggestions.length > 0) {
      handleSelectSuggestion(filteredSuggestions[0]);
    } else {
      alert("No matching result found");
    }
  };

  return (
    <>
      {/* OVERLAY */}
      <div
        className={`menu-overlay ${menuOpen ? "show" : ""}`}
        onClick={closeMenu}
      />

      {/* MOBILE MENU */}
      <div className={`side-menu ${menuOpen ? "open" : ""}`}>
        <div className="close-x" onClick={closeMenu}>×</div>

        <div className="nav-links side-links">
          <Link to="/" onClick={closeMenu}>Home</Link>
          <Link to="/services" onClick={closeMenu}>Services</Link>
          <a onClick={() => { scrollToDoctors(); closeMenu(); }}>Doctors</a>
          <Link to="/about" onClick={closeMenu}>About Us</Link>
          <Link to="/gallery" onClick={closeMenu}>Gallery</Link>
        </div>

        {/* MOBILE SEARCH */}
        <div className="search-wrapper">
          <input
            type="text"
            className="search-box mobile-search"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setShowSuggestions(true);
            }}
            onKeyDown={handleKeyDown}
          />

          {showSuggestions && filteredSuggestions.length > 0 && (
            <ul className="search-suggestions">
              {filteredSuggestions.map((item, i) => (
                <li key={i} onClick={() => handleSelectSuggestion(item)}>
                  {item.label}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* HEADER */}
      <header className="main-header">
        <div className={`top-bar ${scrolled ? "hide" : ""}`}>
          <img src={logo} className="top-logo" alt="Oculus Eye Hospital" />
          <div className="top-actions">
            <button className="btn book-btn" onClick={() => setOpenModal(true)}>
              Book Appointment
            </button>
            <a href="tel:+916000678383" className="btn call-btn">Call Now</a>
          </div>
        </div>

        <nav className={`nav-bar ${scrolled ? "scrolled" : ""}`}>
          <div className="nav-left">
            {scrolled && <img src={wlogo} className="nav-logo" alt="Logo" />}
          </div>

          <div className="nav-right">
            <div className="nav-links">
              <Link to="/">Home</Link>
              <Link to="/services">Services</Link>
              <a onClick={scrollToDoctors}>Doctors</a>
              <Link to="/about">About Us</Link>
              <Link to="/gallery">Gallery</Link>
            </div>

            {/* DESKTOP SEARCH */}
            <div className="search-wrapper">
              <input
                type="text"
                className="search-box desktop-search"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setShowSuggestions(true);
                }}
                onKeyDown={handleKeyDown}
              />

              {showSuggestions && filteredSuggestions.length > 0 && (
                <ul className="search-suggestions">
                  {filteredSuggestions.map((item, i) => (
                    <li key={i} onClick={() => handleSelectSuggestion(item)}>
                      {item.label}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          <div className="burger" onClick={() => setMenuOpen(prev => !prev)}>
            <span className={menuOpen ? "line open" : "line"}></span>
            <span className={menuOpen ? "line open" : "line"}></span>
            <span className={menuOpen ? "line open" : "line"}></span>
          </div>
        </nav>

        <AppointmentModal
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
        />
      </header>
    </>
  );
}
